import { MarketingConsentConfig } from '../reducers/marketing-consent-reducer';
import H from 'history';
import queryString from 'query-string';
import { URLParameters } from '../types';

export interface MarketingConsent {
  consent: boolean;
  locale: string;
  marketingConsentText: string;
  privacyPolicyText?: string;
}

export interface Locale {
  locale: string | null;
}

export const IMPLICIT_CONSENT_TEXT = 'general consent captured';

export type ConsentCheckboxState =
  | { state: 'not_shown' }
  | { state: 'checked'; consentText: string }
  | { state: 'unchecked'; consentText: string };

export const buildMarketingConsent = (
  config: MarketingConsentConfig | null | undefined,
  checkboxState: ConsentCheckboxState,
  privacyPolicyText?: string
): MarketingConsent | null => {
  let marketingConsent: MarketingConsent | null = null;
  if (config && config.locale) {
    const hasConsent = checkboxState.state !== 'not_shown' || config.implicitConsent;
    if (hasConsent) {
      const consent = checkboxState.state === 'checked' || config.implicitConsent;
      // @ts-ignore
      const marketingConsentText = checkboxState.consentText || IMPLICIT_CONSENT_TEXT;
      marketingConsent = {
        consent,
        locale: config.locale,
        marketingConsentText,
      };

      if (privacyPolicyText) {
        marketingConsent = { ...marketingConsent, privacyPolicyText };
      }
    }
  }

  return marketingConsent;
};

const FORCE_SHOW_MARKETING_CONSENT_PARAM = 'showMarketingConsent';

export const isShowMarketingConsentForced = (location: H.Location): boolean => {
  const params: URLParameters = queryString.parse(location.search);
  return FORCE_SHOW_MARKETING_CONSENT_PARAM in params;
};
